export const nullableFields = ['actionWorkingDay'];
export default ['action', 'index', 'offsetdays', 'actionWorkingDay'];
